import React, { useEffect } from 'react';
import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

import './App.css';

import './assets/css/style.css';
import Spinner from './views/Spinner/Spinner';

import CustomerInfoForm from './components/CustomerInfoForm/CustomerInfoForm';
import 'react-toastify/dist/ReactToastify.css';
import HomePage from './views/Home/Home';
import CreateJobPage from './components/CreateJobPage/CreateJobPage';
import ViewJobPage from './components/ViewJobPage/ViewJobPage';
import AllJobsPage from './components/AllJobsPage/AllJobsPage';
import DownloadJobPage from './components/DownloadJobPage/DownloadJobPage';
import TestPDF from './components/TestPDF/TestPDF';
import CreateBarcode from './components/CreateBarcode/CreateBarcode';
import ViewBarcode from './components/ViewBarcode/ViewBarcode';
import DownloadBarcodePage from './components/CreateBarcode/CreateBarcodePDF';
import CftCalculatorPage from './components/CftCalculatorPage/CftCalculatorPage';
import QuotationPricingPage from './components/QuotationPricingPage/QuotationPricingPage';
import QuotationsPage from './components/QuotationsPage/QuotationsPage';
import Sidebar from './views/Sidebar/Sidebar';
import Header from './views/Header/Header';
import Profile from './views/Profile/Profile';
import Settings from './views/Settings/Settings';
import Locked from './views/AccountLocked/AccountLocked';
import Signup from './views/Signup/Signup';
import ResetPassword from './views/ResetPassword/ResetPassword';
import VerifyOTP from './views/VerifyOTP/VerifyOTP';
import VerMessage from './views/VerifiedMessage/VerifiedMessage';
import VerEmail from './views/VerifyEmail/VerifyEmail';
import ResendOTP from './views/ResendOTP/ResendOTP';
import PublicQuotationWizard from './components/PublicQuotationWizard/PublicQuotationWizard';
import PublicCftEntry from './components/PublicQuotationWizard/PublicCftEntry';

toast.configure();

function isPublicQuotePath(pathname) {
  if (pathname === '/public/cft') return true;
  if (pathname === '/quote-request') return true;
  if (/^\/public\/cft\/[^/]+$/.test(pathname)) return true;
  if (/^\/quote-request\/[^/]+$/.test(pathname)) return true;
  return false;
}

/** Routes that do not require auth (landing, quote wizard URLs, signup / verify flows). */
function isPublicPath(pathname) {
  if (isPublicQuotePath(pathname)) return true;
  if (pathname === '/') return true;
  if (pathname === '/blog') return true;
  if (
    pathname === '/signup' ||
    pathname === '/reset-password' ||
    pathname === '/verify-otp' ||
    pathname === '/resend-otp' ||
    pathname === '/verify-email' ||
    pathname.startsWith('/verified-message/')
  ) {
    return true;
  }
  return false;
}

function App() {
  const history = useHistory();
  const location = useLocation();

  const { authUser, logout } = useSelector((state) => state.Auth);

  useEffect(() => {
    if (isPublicPath(location.pathname)) return;
    if (
      location.pathname !== '/login' &&
      (authUser === null || authUser === undefined || authUser === 'undefined')
    ) {
      history.push('/login');
    } else if (location.pathname === '/login' && authUser && !logout) {
      history.push('/');
    }
  }, [authUser, history, location.pathname, logout]);

  let mainContent = (
    <>
      <Route
        exact
        path='/'
        component={React.lazy(() => import('./views/AceLanding/AceLanding'))}
      />
      <Route exact path="/blog" component={React.lazy(() => import('./views/AceBlog/AceBlog'))} />
       <Route
        exact
        path='/login'
        component={React.lazy(() => import('./views/Login/Login'))}
      />
      <Route path='/signup' component={Signup} exact/>
      <Route path='/reset-password' component={ResetPassword} exact/>
      <Route path='/verify-otp' component={VerifyOTP} exact/>
      <Route path='/resend-otp' component={ResendOTP} exact/>
      <Route path='/verified-message/:id/:email' component={VerMessage} exact/>
      <Route path='/verify-email' component={VerEmail} exact/>
    </>
  )

  if(authUser) {
    mainContent = (
      <>
          <Route path='/customer' component={CustomerInfoForm} />
          <Route path="/blog" exact component={React.lazy(() => import('./views/AceBlog/AceBlog'))} />
          <Route path='/' component={HomePage}  exact/>
          <Route path='/create-job' component={CreateJobPage} exact />
          <Route path='/edit-job/:jobId' component={CreateJobPage} />
          <Route path='/view-job/:jobId' component={ViewJobPage} />
          <Route path='/jobs' component={AllJobsPage} exact />
          <Route path='/jobs/edit/:jobId' component={CreateJobPage} />
          <Route path='/download-job' component={DownloadJobPage} />
          <Route path='/download-barcode' component={DownloadBarcodePage} />
          <Route path='/test-pdf' component={TestPDF} />
          <Route path='/create-barcode' component={CreateBarcode} />
          <Route path='/barcode' component={ViewBarcode} exact/>
          <Route path='/cft-calculator' component={CftCalculatorPage} exact />
          <Route path='/quotations' component={QuotationsPage} exact />
          <Route path='/quotations/new' component={CftCalculatorPage} exact />
          <Route path='/quotations/:quotationId/pricing' component={QuotationPricingPage} exact />
          <Route path='/quotations/:quotationId/edit' component={CftCalculatorPage} exact />
          <Route path='/quotations/:quotationId' component={CftCalculatorPage} exact />
          <Route path='/profile' component={Profile} exact/>
          <Route path='/settings-profile' component={Settings} exact/>
          <Route path='/account-locked' component={Locked} exact/>
          
      </>
    )
  }

  return (
    <React.Suspense fallback={<Spinner/>}>
      <Switch>
        <Route path="/public/cft" exact component={PublicCftEntry} />
        <Route path="/quote-request" exact component={PublicCftEntry} />
        <Route path="/public/cft/:token" exact component={PublicQuotationWizard} />
        <Route path="/quote-request/:token" exact component={PublicQuotationWizard} />
        <Route
          render={() => (
            <React.Fragment>
              {authUser && (
                <>
                  <Header />
                  <Sidebar />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              )}
              <div style={{ marginLeft: authUser ? '100px' : 0 }}>{mainContent}</div>
              <br />
              <br />
              <br />
            </React.Fragment>
          )}
        />
      </Switch>
      <div style={{ position: 'fixed', top: '92px', right: '92px', zIndex: '3' }}>
        <ToastContainer containerId='appLayoutToaster' />
      </div>
    </React.Suspense>
  );
}

export default App;